import LoadingSpinner from '@passkeys/ui/loading-spinner';

function TokenItemSpinner() {
  return (
    <div className="flex size-6 items-center justify-center rounded-full border border-white/6 bg-black text-white theme-dark:bg-white/85 theme-dark:text-black">
      <LoadingSpinner size={16} />
    </div>
  );
}

export default TokenItemSpinner;
